import {IManualExecutionBoundsProductsProvider} from "./ManualExecutionBounds";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {WB_CustomerRow, WB_FinishedProductRow, WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import {PlanningDataUtils} from "../PA.TPM.Core/PlanningDataUtils";
import {ASync} from "../PA.Core/Basic/ASync";
import {CannibalizationDataUtils} from "../PA.Consumption.Core/CannibalizationDataUtils";
import {ProductHierarchyService} from "../PA.MD.Services/ProductHierarchyService";
import {Product_Hierarchy_OrgLevel_Product} from "../PA.MD.Core/MD.Constants";
import {esWB_Finished_Product} from "../PA.Core/PAdbSchema";


export class PlanningDataManualExecutionBoundsProductsProvider
  implements IManualExecutionBoundsProductsProvider
{
  getProducts(dbContext: PAdbContext,
              WB_PlanningCustomerRows: WB_CustomerRow[],
              WB_SourceCustomerRows: WB_CustomerRow[],
              WB_ProductGroupRows: WB_ProductGroupRow[],
              Effective_Start_Dt: Date,
              Effective_End_Dt: Date): Promise<WB_FinishedProductRow[]> {

    return PlanningDataUtils.getProducts(dbContext, WB_PlanningCustomerRows, WB_ProductGroupRows)

  }

}


export class CannibalizationGroupManualExecutionBoundsProductsProvider
  implements IManualExecutionBoundsProductsProvider
{
  getProducts(dbContext: PAdbContext,
              WB_PlanningCustomerRows: WB_CustomerRow[],
              WB_SourceCustomerRows: WB_CustomerRow[],
              WB_ProductGroupRows: WB_ProductGroupRow[],
              Effective_Start_Dt: Date,
              Effective_End_Dt: Date): Promise<WB_FinishedProductRow[]> {

    return CannibalizationDataUtils.getAffinityGroupProducts(dbContext, WB_ProductGroupRows)

  }

}

export class ProductHierarchyManualExecutionBoundsProductsProvider
  implements IManualExecutionBoundsProductsProvider
{
  private _wbPrdHId: number

  constructor(wbPrdHId: number){
    this._wbPrdHId = wbPrdHId
  }

  async getProducts(dbContext: PAdbContext,
                    WB_PlanningCustomerRows: WB_CustomerRow[],
                    WB_SourceCustomerRows: WB_CustomerRow[],
                    WB_ProductGroupRows: WB_ProductGroupRow[],
                    Effective_Start_Dt: Date,
                    Effective_End_Dt: Date): Promise<WB_FinishedProductRow[]> {

    const self = this

    let arrReturnWBIds: number[] = []

    for (let prdGrpRow of WB_ProductGroupRows) {
      let arrWBPrdIds = await ProductHierarchyService.getChildren(self._wbPrdHId, prdGrpRow.cif.WB_PRDGRP_ID, Effective_Start_Dt, Effective_End_Dt, Product_Hierarchy_OrgLevel_Product)
      arrReturnWBIds.push.apply(arrReturnWBIds, arrWBPrdIds)
    }

    let returnValue = <WB_FinishedProductRow[]>await dbContext.findUsingCache(esWB_Finished_Product, arrReturnWBIds)
    return returnValue
  }

}


